import { config } from "./config";

// 测试环境中文文案；保留品牌、路径、接口字段和存储键。
const zh: Record<string, string> = {
  "Advertising measurement": "广告效果统计",
  "Allow us to share page visits, Home Screen actions and playback events with Meta, including browser information and advertising identifiers, to measure our ads? You can watch without accepting and change this choice here at any time.": "是否允许我们向 Meta 分享网页访问、桌面操作和播放事件，以及浏览器信息和广告标识，用于统计广告效果？拒绝也能正常观看，之后可随时在这里修改选择。",
  "Do not allow": "不允许",
  "Allow measurement": "允许统计",
  "Advertising settings": "广告统计设置",
  "Allowed": "已允许",
  "Not allowed": "未允许",
  "Your list and history stay with this account. Accounts cannot be transferred.": "收藏和观看记录归属当前账户，不支持迁移。",
  "Stories, covers and episode listings are demo content. Favorites and history belong to this device account. Real payments and advertising reports are not connected.": "剧集、封面和选集列表均为演示内容。收藏和观看记录归属本机账户，真实支付和广告报表尚未接入。",
  "This clears saved stories and watch history for this account, and preview unlocks on this device.": "这会清除当前账户的收藏、观看记录及本机模拟解锁记录。",
  "Allow this site to save data so your account can be created.": "请允许本站保存 Cookie，才能自动创建并保留本机账户。",
  "Preparing your account…": "正在准备本机账户…",
  "Account connection unavailable": "暂时无法连接本机账户",
  "Your account is created automatically. No registration needed.": "首次打开将自动创建账户，无需注册或输入密码。",
  "Automatically created for this device. No registration needed.": "账户已自动创建，无需注册或输入密码。",
  "Bound to this client": "已绑定当前客户端",
  "Client number": "客户端编号",
  "Copy {0}": "复制{0}",
  "Copy": "复制",
  "Copied": "已复制",
  "Long press the number to copy it.": "请长按编号手动复制。",
  "Give these numbers to the administrator to find your account. They cannot be used to sign in.": "将编号提供给管理员，即可在后台找到对应账户。编号不能用于登录。",
  "Account stays with this client": "本机专属账户",
  "Accounts cannot be switched, transferred or restored on another device.": "不支持切换账户、换绑，或在其他设备恢复此账户。",
  "Clearing site data, using another browser or reinstalling may create a new account. Keep site data to retain access.": "清除网站数据、更换浏览器或重新安装，可能产生新账户。请保留网站数据，以继续使用当前账户。",
  "The client number identifies this browser or Home Screen app, not your phone's hardware.": "客户端编号对应浏览器或桌面应用的存储环境，不是手机硬件编号。",
  "Saved to this account": "已保存到本机账户",
  "Add to desktop": "添加到桌面",
  "Add again": "重新添加",
  "Avoid duplicate icons": "避免重复添加图标",
  "Already have a Yestv icon on your Home Screen?": "桌面已有 Yestv 图标？",
  "Return to your Home Screen and tap Yestv. There is no need to add another icon.": "返回主屏幕点击 Yestv 图标即可，无需重复添加。",
  "If the icon is missing or was deleted, follow the steps below to add it again.": "找不到或已删除图标，可以按下方步骤重新添加。",
  "I’ve already added it": "我已添加",
  "We’ll stop suggesting it here. You can still choose Add again later.": "此处不再主动提示添加，之后仍可选择「重新添加」。",
  "Add Yestv to your desktop": "添加到桌面",
  "Your Home Screen icon": "添加后，桌面上会出现这个图标",
  "Add it using Safari on your iPhone or iPad.":
    "请用 iPhone 或 iPad 的 Safari 完成添加。",
  "Tap to see the illustrated steps for Safari.":
    "点击查看 Safari 的三步图文引导",
  "Follow these three steps in Safari. There is nothing to download or fill in.":
    "请在 Safari 中按下图操作，无需下载或填写信息。",
  "The icon and name are ready. Keep Open as Web App on if shown, then tap Add.":
    "图标和名称已准备好。如有「作为网页 App 打开」，保持开启，再点「添加」。",
  Illustration: "操作示意",
  "Link copied": "已复制链接",
  "Open Safari, paste the link into the address bar, then visit the page.":
    "请打开 Safari，将链接粘贴到地址栏并访问。",
  "Open this page in Safari on your iPhone or iPad":
    "请在 iPhone 或 iPad 的 Safari 中打开",
  "Copy this link, switch to Safari, and paste it into the address bar.":
    "复制下方网址，切换到 Safari，粘贴到地址栏访问。",
  "Send the link below to your iPhone or iPad, then open it in Safari.":
    "将下方网址发送到你的 iPhone 或 iPad，用 Safari 打开。",
  "Then tap Add to desktop on that page to see the three steps.":
    "打开后，点击页面上的「添加到桌面」，按三步图示操作。",
  "Already in Safari? View the steps": "已经在 Safari 中？查看添加步骤",
  "Preview the iPhone steps": "预览苹果手机的添加步骤",
  "If it is still missing, copy this link and open it in the Safari app.":
    "如果仍然没有这个选项，请复制下方网址，切换到 Safari App 打开。",
  "After adding, return to your Home Screen and tap the Yestv icon to open it.":
    "添加完成后，回到手机桌面，点击 Yestv 图标打开。",
  "Close guide": "收起引导",
  "Keep Yestv on your Home Screen": "加到桌面，下次一键打开",
  "Tap below, then confirm in your browser.":
    "点击下方按钮，在弹出的窗口中确认安装。",
  "Open in Safari to add it to your Home Screen.":
    "请用 Safari 打开，再添加到主屏幕。",
  "Open in Chrome to add it to your Home Screen.":
    "请用 Chrome 打开，再添加到主屏幕。",
  "Safari: Share → Add to Home Screen → Add":
    "Safari 共享 → 添加到主屏幕 → 添加",
  "Open the browser menu to install, or see the steps below.":
    "通过浏览器菜单添加，点击下方查看步骤。",
  "Install now": "立即安装",
  "Added to your Home Screen": "已添加到桌面",
  "Next time, tap the Yestv icon to start watching.":
    "添加后，点击桌面的 Yestv 图标就能打开观看。",
  "Tap Safari’s Share button": "点击 Safari 的「共享」",
  "Look for the square with an upward arrow. You may need to open the page menu first.":
    "找到方框向上箭头图标；部分版本需先点页面菜单，再点「共享」。",
  "Choose Add to Home Screen": "选择「添加到主屏幕」",
  "Scroll down the share menu to find this option.":
    "在共享菜单中向下滑动，就能找到这个选项。",
  "Confirm with Add": "点击「添加」，完成",
  "Keep Open as Web App on if shown. Then tap the Yestv icon on your Home Screen.":
    "如有「作为网页 App 打开」，保持开启，再点「添加」。",
  "Open your browser menu": "打开浏览器菜单",
  "In Chrome, tap the three dots at the top right.":
    "在 Chrome 中，点击右上角的三个点。",
  "Choose Install app or Add to Home Screen":
    "选择「安装应用」或「添加到主屏幕」",
  "The wording depends on your browser. Chrome is recommended if this option is missing.":
    "不同浏览器的名称可能不同；找不到时可用 Chrome 打开。",
  "Confirm the installation": "确认添加",
  "Then open Yestv from the new icon on your Home Screen.":
    "回到手机桌面，点击新出现的 Yestv 图标即可打开。",
  "In Chrome or Edge, look for Install app in the menu or address bar.":
    "在 Chrome 或 Edge 的菜单或地址栏中，找到安装应用入口。",
  "Install Yestv": "安装 Yestv",
  "On Mac Safari, choose File, then Add to Dock if available.":
    "Mac Safari 可在「文件」菜单中选择「添加到程序坞」（如有）。",
  "Next time, open Yestv from its app icon.":
    "以后点击 Yestv 应用图标即可打开。",
  "First, open this page in Safari": "先用 Safari 打开此页面",
  "First, open this page in Chrome": "先用 Chrome 打开此页面",
  "Copy the link below and paste it into the browser’s address bar.":
    "复制下方网址，打开浏览器，粘贴到地址栏访问。",
  "Website address": "用户端网址",
  "Copy link": "复制链接",
  "Link copied. Open your browser and paste it into the address bar.":
    "已复制，请打开浏览器并粘贴到地址栏。",
  "Press and hold the selected address to copy it.":
    "请长按已选中的网址，选择复制。",
  "Can’t find Add to Home Screen?": "找不到「添加到主屏幕」？",
  "Scroll to the bottom of Safari’s share menu, tap Edit Actions, then add Add to Home Screen.":
    "滑到 Safari 共享菜单底部，点击「编辑操作」，将「添加到主屏幕」加入列表。",
  "No App Store download needed": "无需前往应用商店下载",
  "Loading your account…": "正在加载账号…",
  "Loading stories…": "正在加载剧集…",
  "Loading video…": "正在加载视频…",
  "{0} illustrated cover": "《{0}》封面",
  "Close dialog": "关闭弹窗",
  "View {0}": "查看《{0}》",
  episodes: "集",
  "For you": "推荐",
  "The library could not be loaded.": "无法加载剧集，请稍后重试。",
  All: "全部",
  "Removed from your list": "已取消收藏",
  "Added to your list": "已加入收藏",
  "Could not sync your list. Please try again.": "收藏同步失败，请重试。",
  "Preview episode unlocked. No payment taken.": "已解锁测试剧集，未产生扣费。",
  "Episode {0}{1}": "第 {0} 集{1}",
  ", locked": "，未解锁",
  "Yestv home": "Yestv 首页",
  "Main navigation": "主导航",
  Discover: "发现",
  "My list": "我的收藏",
  PREVIEW: "预览版",
  "Search stories": "搜索剧集",
  "Your profile": "个人资料",
  "You're offline. Saved pages are available; videos need a connection.":
    "当前没有网络。已缓存的页面可以打开，观看视频需要联网。",
  "A new version is ready.": "新版本已准备好。",
  "Update now": "立即更新",
  "Finding your next story…": "正在加载推荐剧集…",
  "Our next chapter is coming.": "剧集暂时无法加载",
  "Try again": "重试",
  "SMALL EPISODES. BIG FEELINGS.": "短短几分钟，精彩好故事",
  "A little escape, whenever you need it.": "随时打开，放松片刻。",
  "Browse by genre": "按分类浏览",
  Romance: "爱情",
  Fantasy: "奇幻",
  Mystery: "悬疑",
  Drama: "剧情",
  "Featured story": "精选剧集",
  "ORIGINAL SERIES": "原创剧集",
  "LOVE WAS NEVER PART OF THE DEAL.": "这场交易，从未约定爱情。",
  "The Midnight": "午夜",
  Contract: "契约",
  "Every episode brings you closer.": "每一集，都离真相更近。",
  "Start watching": "开始观看",
  "Remove featured story from my list": "取消收藏精选剧集",
  "Save featured story to my list": "收藏精选剧集",
  "Featured stories": "精选剧集轮播",
  "Feature {0}": "展示《{0}》",
  stories: "部剧集",
  series: "部",
  "More stories are on the way.": "更多剧集即将上线。",
  "Pick up where you left off": "继续上次观看",
  History: "观看记录",
  "YOUR NEXT OBSESSION": "发现下一部好剧",
  "Worth one more episode": "好剧再看一集",
  "Explore all": "查看全部",
  "Big stories. Small breaks.": "片刻休息，精彩故事。",
  "Two minutes can change everything.": "两分钟，开启一段新故事。",
  MIN: "分钟",
  "Your next story, one tap away.": "一键打开，继续追剧。",
  "Add Yestv to your Home Screen.": "将 Yestv 添加到主屏幕。",
  "Add Yestv to Home Screen": "将 Yestv 添加到主屏幕",
  "FIND YOUR NEXT CHAPTER": "发现更多精彩",
  "Follow your curiosity": "找一部你喜欢的剧",
  "Search stories, genres…": "搜索剧名、分类…",
  "Clear search": "清空搜索",
  "Search results": "搜索结果",
  "Find your feeling": "全部剧集",
  "No stories found": "没有找到相关剧集",
  "Try another title or genre.": "试试其他剧名或分类。",
  "Clear filters": "清除筛选",
  "Back to series": "返回剧集详情",
  "Back to stories": "返回剧集列表",
  "YESTV ORIGINAL": "Yestv 原创",
  "min each": "分钟 / 集",
  "Continue watching": "继续观看",
  "Remove from my list": "取消收藏",
  "Add to my list": "加入收藏",
  "Playback is coming soon": "视频即将上线",
  "Unlock episode {0}": "解锁第 {0} 集",
  "This episode is not available yet.": "本集暂时无法观看。",
  "Continue the story for {0}.": "支付 {0} 可继续观看本集。",
  "Unlock episode": "解锁本集",
  "The sample video could not load.": "示例视频加载失败。",
  "Retry video": "重新加载视频",
  "NOW PLAYING": "正在播放",
  Previous: "上一集",
  "Next episode": "下一集",
  "In your list": "已收藏",
  "Save to your list": "加入收藏",
  "Demo player · Sample footage from": "测试播放器 · 示例片段来自",
  Sintel: "辛特尔",
  ". Story covers and episode listings are illustrative.":
    "。剧集封面和选集列表仅作演示。",
  Episodes: "选集",
  "/ episode": "/ 集",
  "Your next chapter": "猜你喜欢",
  "KEEP THE GOOD STORIES CLOSE": "把好故事留在身边",
  "Your little escape": "我的片单",
  "Watch history": "观看记录",
  "Make room for a good story.": "收藏你的下一部好剧",
  "Every story starts somewhere.": "还没有观看记录",
  "Tap + on a story to keep it here for later.":
    "点击剧集上的“＋”，即可收藏到这里。",
  "Your recently watched episodes will appear here.":
    "最近观看的剧集会显示在这里。",
  "Find a story": "去找剧",
  "Your list and history sync to your account.":
    "收藏和观看记录已同步到你的账号。",
  "Your list and history are saved on this device. Sign in to sync across devices.":
    "收藏和观看记录保存在当前设备，登录后可跨设备同步。",
  "YOUR SPACE": "个人中心",
  "More stories. More you": "我的追剧时光",
  "Guest viewer": "游客",
  "Your personal corner of Yestv.": "管理你的账号和追剧记录。",
  TEST: "测试版",
  GUEST: "游客",
  "Saved stories": "收藏剧集",
  "Stories started": "已观看剧集",
  "Demo unlocks": "测试解锁",
  "Manage my account": "管理我的账号",
  "Sign in or create an account": "登录或注册账号",
  "My list & watch history": "收藏与观看记录",
  "Yestv is on your Home Screen": "已从主屏幕打开 Yestv",
  "Add to Home Screen": "添加到主屏幕",
  "About this version": "关于此版本",
  "Clear my account history & list": "清空账号的收藏与观看记录",
  "Clear this device’s history & list": "清空本设备的收藏与观看记录",
  "You’re exploring the preview. All unlocks are simulated, and no money is collected.":
    "当前为预览版，解锁仅作演示，不会收取费用。",
  "Your viewing preferences stay on this device.": "观看偏好保存在当前设备。",
  "A little story. A little escape.": "片刻时光，一个好故事。",
  "This chapter is missing.": "页面不存在",
  "Let’s find you another story.": "返回首页，发现其他精彩剧集。",
  "Back to home": "返回首页",
  "Stories worth staying for.": "好故事，值得停留。",
  "About Yestv": "关于 Yestv",
  "Mobile navigation": "底部导航",
  Home: "首页",
  Me: "我的",
  "Episode price": "单集价格",
  "Preview checkout": "测试解锁",
  "This is a simulated unlock. No payment or card details are required.":
    "此操作仅模拟解锁，无需付款或填写银行卡信息。",
  "Try unlocking this episode": "体验解锁本集",
  "Purchases are not available yet. Please try again later.":
    "购买功能暂未开放，请稍后再试。",
  "Back to story": "返回剧集",
  "Only this episode is unlocked. No subscription.":
    "仅解锁本集，不会开通订阅。",
  "Keep Yestv close": "添加到主屏幕",
  "Yestv app icon": "Yestv 应用图标",
  "Your next story,": "下一部好剧，",
  "one tap away.": "一键即达。",
  "Yestv is already running from your Home Screen.":
    "当前已从主屏幕打开 Yestv。",
  "On your iPhone, open this page in Safari:":
    "请在 iPhone 上使用 Safari 打开本页：",
  "Tap the": "点击",
  Share: "分享",
  "button.": "按钮。",
  Choose: "选择",
  Keep: "如果显示",
  "Open as Web App": "作为网页 App 打开",
  "enabled if shown, then tap": "，请保持开启，然后点击",
  Add: "添加",
  "Opened from Facebook? Use its menu to open this page in Safari first.":
    "如果从 Facebook 内打开，请先通过菜单选择在 Safari 中打开。",
  "Got it": "知道了",
  "Small episodes. Big feelings.": "短短几分钟，精彩好故事。",
  "Original animated short stories, made for the little breaks in your day.":
    "原创动画短剧，陪你度过休息时光。",
  "Test environment · No real purchases": "测试环境 · 不会产生真实支付",
  "Stories, covers and episode listings are demo content. Sign in to sync favorites and history. Simulated unlocks stay on this device. Real payments and advertising reports are not connected.":
    "剧集、封面和选集列表均为演示内容。登录后可同步收藏与观看记录，模拟解锁仅保存在当前设备。真实支付和广告报表尚未接入。",
  Version: "版本",
  Environment: "环境",
  Mode: "打开方式",
  "Home Screen app": "主屏幕应用",
  Browser: "浏览器",
  Connection: "连接",
  Secure: "安全连接",
  "Local HTTP preview": "本地 HTTP 预览",
  Build: "构建版本",
  "Clear your account library?": "清空账号的收藏与观看记录？",
  "Clear this device’s library?": "清空本设备的收藏与观看记录？",
  "This clears your saved stories and watch history across devices, and preview unlocks on this device.":
    "将清空账号在所有设备上的收藏和观看记录，以及当前设备的测试解锁记录。",
  "This clears your saved stories, watch history and preview unlocks on this device.":
    "将清空当前设备的收藏、观看记录和测试解锁记录。",
  "Your library has been cleared.": "收藏与观看记录已清空。",
  "Some records could not be cleared. Please retry.":
    "部分记录清理失败，请重试。",
  "Clear library": "确认清空",
  "Keep my library": "取消",
  "Yestv · Watch": "Yestv · 在线追剧",
  "Yestv · Playback test": "Yestv · 播放测试",
  "We couldn’t connect to the video website.": "无法连接视频站点，请稍后重试。",
  "Connect to the internet to start watching.": "请连接网络后再观看。",
  "Yestv is taking a short break. Please try again later.":
    "服务暂时不可用，请稍后重试。",
  "My account": "我的账号",
  "About this preview": "关于测试版",
  "Video website": "视频播放区域",
  "A LITTLE PAUSE": "连接暂时中断",
  "Let’s reconnect.": "重新连接",
  "Getting your story ready…": "正在准备视频…",
  "YOUR NEXT STORY": "开始新的故事",
  "Ready when you are.": "准备好开始观看了吗？",
  "Continue to": "前往",
  "to start watching.": "开始观看。",
  "Opening your story…": "正在打开视频…",
  "This is taking a little longer.": "加载时间较长，请稍候。",
  Retry: "重试",
  "Open directly": "直接打开",
  "✓ Saved": "✓ 已收藏",
  "+ Save story": "+ 收藏视频",
  "Sample video · Playback preview": "示例视频 · 播放测试",
  "Your stories, one tap away.": "精彩故事，一键即达。",
  "On your Home Screen": "已从主屏幕打开",
  "KEEP YOUR NEXT STORY CLOSE": "随时打开，继续追剧",
  "One tap. You’re back.": "点击图标，即可回来。",
  "Add Yestv to your iPhone Home Screen for easy access.":
    "将 Yestv 添加到 iPhone 主屏幕，下次打开更方便。",
  "Open this page in": "打开本页请使用",
  Tap: "点击",
  "in the browser menu.": "（位于浏览器菜单中）。",
  ", enable": "，如有以下选项，请开启",
  "if shown, then tap Add.": "，最后点击“添加”。",
  "On a computer, use your browser’s install option when available.":
    "在电脑上，可使用浏览器提供的“安装应用”功能。",
  "YESTV PREVIEW": "Yestv 测试版",
  "Just press play.": "点击播放，开始体验。",
  "This preview opens a sample video page so you can try the viewing experience. The existing video website has not been connected yet.":
    "当前提供示例视频，用于测试播放体验，尚未接入真实视频站点。",
  "Yestv opens the configured video website. Your video account and purchases are managed by that website.":
    "Yestv 会打开已配置的视频站点，视频账号与购买记录由该站点管理。",
  "No sign-in or payment required": "示例视频无需登录或付费",
  "Sample footage: Sintel, © Blender Foundation":
    "示例片段：《辛特尔》，© Blender Foundation",
  "Sintel · CC BY 3.0": "辛特尔 · CC BY 3.0",
  "Open video page directly": "直接打开视频页面",
  "Sintel · Yestv playback preview": "辛特尔 · Yestv 播放测试",
  "Tap play to try again. Check your connection if the video does not load.":
    "点击播放重试；如果仍无法加载，请检查网络。",
  "Full screen is unavailable here. You can keep watching in this window.":
    "当前无法进入全屏，可以继续在此窗口观看。",
  "Sintel sample video": "辛特尔示例视频",
  "The video couldn’t load. Check your connection and try again.":
    "视频加载失败，请检查网络后重试。",
  "PLAYBACK PREVIEW": "播放测试",
  "Buffering video": "视频缓冲中",
  "Replay video": "重新播放视频",
  "Play video": "播放视频",
  "Watch again": "再看一次",
  "Tap to play": "点击播放",
  "A BLENDER OPEN MOVIE": "Blender 开源动画短片",
  "A journey worth following.": "一段值得追随的旅程。",
  "Video progress": "播放进度",
  "Pause video": "暂停视频",
  "Resume video": "继续播放视频",
  Pause: "暂停",
  Replay: "重播",
  Play: "播放",
  "Unmute video": "开启声音",
  "Mute video": "静音",
  "Full screen": "全屏",
  "Sample footage · © Blender Foundation · CC BY 3.0":
    "示例片段 · © Blender Foundation · CC BY 3.0",
  "My account · Yestv": "我的账号 · Yestv",
  "Please try again.": "请稍后重试。",
  "Passwords do not match.": "两次输入的密码不一致。",
  Avatar: "头像",
  "{0} avatar": "{0}头像",
  "Back to watching": "返回观看",
  "Your stories.": "你的故事，",
  "Your place.": "你的专属空间。",
  "One account for your saved stories and watch history.":
    "登录账号，同步收藏和观看记录。",
  "Retry connection": "重新连接",
  "User ID": "用户 ID",
  "Profile saved.": "个人资料已保存。",
  Nickname: "昵称",
  "Save profile": "保存资料",
  "Change password": "修改密码",
  "Password updated. Please sign in again.": "密码已修改，请重新登录。",
  "Current password": "当前密码",
  "New password": "新密码",
  "Update password": "保存新密码",
  "Signed out of this device.": "已退出当前设备的登录。",
  "Sign out": "退出登录",
  "Welcome, viewer.": "欢迎来到 Yestv",
  "You can keep watching as a guest.": "你也可以使用游客模式继续观看。",
  "Guest ID": "游客 ID",
  "Sign in": "登录",
  "Create account": "注册账号",
  Email: "邮箱",
  Password: "密码",
  "Confirm password": "确认密码",
  "Please wait…": "请稍候…",
  "Create my account": "创建账号",
  "Your guest list and history will join your account when you sign in.":
    "登录后，本设备的游客收藏和观看记录会合并到账号中。",
  "Your library": "我的片单",
  "Synced to your account": "已同步到账号",
  "Saved on this device": "保存在当前设备",
  "Episode {0} · {1}s watched": "第 {0} 集 · 已观看 {1} 秒",
  "Ready when you are": "随时开始观看",
  Watch: "观看",
  Remove: "移除",
  "A place for your next story.": "这里还没有剧集",
  "Save a story while watching to find it here.":
    "观看时收藏喜欢的剧集，就能在这里找到。",
  "Your viewing progress will appear here.": "观看后，播放进度会显示在这里。",
  "Start watching →": "开始观看 →",
  "Could not save. Please try again.": "保存失败，请重试。",
  "Your device library will sync when the connection returns.":
    "网络恢复后，将同步本设备的收藏与观看记录。",
  "Could not connect to your account.": "无法连接账号服务，请稍后重试。",
  "Account environment mismatch.": "账号服务环境不匹配，请刷新页面后重试。",
  "Your latest change could not be synced. Please retry when connected.":
    "最新修改同步失败，请在网络恢复后重试。",
  "The Midnight Contract": "午夜契约",
  "One signature. A thousand secrets.": "一纸契约，千重秘密。",
  "When an ambitious illustrator signs a mysterious contract, her quiet life collides with the heir to a powerful empire. Every promise has a price. Every episode reveals a secret.":
    "一位怀揣梦想的插画师签下一份神秘契约，从此与商业帝国的继承人产生交集。每个承诺都有代价，每一集都揭开一个秘密。",
  "The Moonlit Crown": "月下王冠",
  "A kingdom to save. A heart to lose.": "守护王国，还是交付真心。",
  "A forgotten heir returns to a moonlit kingdom, where her greatest rival may be the only person she can trust.":
    "被遗忘的继承人重返月色中的王国，却发现最大的对手，或许是唯一值得信任的人。",
  NEW: "新剧",
  "The Last Train Home": "归途末班车",
  "Some strangers feel like destiny.": "有些相遇，仿佛命中注定。",
  "Two strangers miss the last train. One unexpected night opens the door to the lives they were afraid to choose.":
    "两个陌生人错过了末班车。一个意外的夜晚，让他们鼓起勇气，走向曾经不敢选择的人生。",
  "JUST ADDED": "刚刚上线",
  "After the Last Promise": "最后的承诺",
  "The truth changes everything.": "真相，改变一切。",
  "An unsigned letter draws a young attorney back into a family mystery she thought she had left behind.":
    "一封没有署名的信，让年轻律师重新卷入一桩家族谜案，而她曾以为往事早已结束。",
  "Our library is not available yet. Please check back soon.":
    "剧集暂未上线，请稍后再来。",
  "The library response could not be loaded.": "剧集数据加载失败。",
  "First {0} episodes on us · {1} / episode after":
    "前 {0} 集免费，后续每集 {1}",
  "First {0} episodes free · {1} per locked episode":
    "前 {0} 集免费，未解锁剧集每集 {1}",
  "Episode {0} of {1}": "第 {0} 集 / 共 {1} 集",
  "Episode {0}": "第 {0} 集",
  "{0} free episodes to get you started.": "可免费观看前 {0} 集。",
  "Resume episode {0}": "继续观看第 {0} 集",
  "Episode {0} · Single episode": "第 {0} 集 · 单集解锁",
  "Saved ({0})": "收藏（{0}）",
  "History ({0})": "观看记录（{0}）",
};

export function t(source: string, ...values: (string | number)[]): string {
  const text = config.locale === "zh-CN" ? (zh[source] ?? source) : source;
  return text.replace(/\{(\d+)\}/g, (match, index: string) =>
    String(values[Number(index)] ?? match),
  );
}

export const environmentLabel =
  config.locale === "zh-CN"
    ? { development: "开发环境", staging: "测试环境", production: "正式环境" }[
        config.environment
      ]
    : config.environment;

export const avatarLabels: Record<string, string> =
  config.locale === "zh-CN"
    ? { leaf: "花朵", moon: "月亮", sun: "太阳", ocean: "海洋" }
    : { leaf: "leaf", moon: "moon", sun: "sun", ocean: "ocean" };
